import { EffectsMap } from 'use-effect-reducer'
import { getPaymentErrorMessage } from '../../helpers/errorChecking'
import { processLSPayPaymentMethodOnFile } from '../../../../../functions/payment-types/lspayPmof'
import { SWIPER_ERROR_CODES } from '../../helpers/lspayConstants'
import { LSPAYErrorMessage } from '../../helpers/lspay.types'
import { PMOFEffect, PMOFEffectsMapArgs, PMOFEvent, PMOFState } from './types'

export const getPMOFEffectsMap = (
  args: PMOFEffectsMapArgs
): EffectsMap<PMOFState, PMOFEvent, PMOFEffect> => {
  const {
    amount,
    customerId,
    paymentMethodOnFileId,
    register,
    registerSaleId,
    setSwiperError,
    transactionId,
  } = args

  return {
    processPaymentEffect: (_state, _effect, dispatch) => {
      if (!customerId || !paymentMethodOnFileId) {
        // Guard: required identifiers missing; do not attempt network call.
        return
      }

      processLSPayPaymentMethodOnFile(
        amount.toNumber(),
        customerId,
        paymentMethodOnFileId,
        register.id,
        register.name,
        registerSaleId || '',
        transactionId
      )
        .then(transaction => {
          dispatch({ type: 'DONE', transaction })
        })
        .catch(error => {
          if (Object.values(SWIPER_ERROR_CODES).includes(error.code)) {
            setSwiperError(error)
            return
          }

          const errorMessage: LSPAYErrorMessage = getPaymentErrorMessage(error)
          dispatch({ type: 'ERROR', errorMessage })
        })
    },
  }
}
